import React from "react";
import { RideGlFireSolid } from "@rimac-seguros/ride-system-components";
import useBreakpoint from "@/hooks/useBreakpoint";
import "./styles.scss";

const glyphComponents = {
  RideGlFireSolid,
};

export const HighlightBanner = ({
  text,
  activeGlyph,
  nameGlyph = "RideGlFireSolid",
}) => {
  const isDesktop = useBreakpoint("large-min");
  const GlyphComponent =
    (nameGlyph && glyphComponents[nameGlyph]) ||
    glyphComponents["RideGlFireSolid"];

  const isMultipleWords = text.trim().split(/\s+/).length > 1;

  return (
    <>
      {activeGlyph && GlyphComponent && (
        <GlyphComponent size={isDesktop ? "x-large" : "large"} fill="#FFFFFF" />
      )}
      <div className={`highlight-text ${!isMultipleWords ? "one-word" : ""}`}>
        <p>{text}</p>
      </div>
      {activeGlyph && GlyphComponent && (
        <GlyphComponent size={isDesktop ? "x-large" : "large"} fill="#FFFFFF" />
      )}
    </>
  );
};
